export default __webpack_public_path__ + "static/media/Alerts.69b068ec.svg";